/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetEquipmentBulkEditViewRequest = {
  /**
   * The device kind to get the bulk edit view for
   */
  deviceKind: string;
  /**
   * Optional filter of device ids to include in the bulk edit view
   */
  deviceIds?: Array<string> | undefined;
  agentId: string;
};

/** @internal */
export const GetEquipmentBulkEditViewRequest$inboundSchema: z.ZodType<
  GetEquipmentBulkEditViewRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  device_kind: types.string(),
  device_ids: types.optional(z.array(types.string())),
  agent_id: types.string(),
}).transform((v) => {
  return remap$(v, {
    "device_kind": "deviceKind",
    "device_ids": "deviceIds",
    "agent_id": "agentId",
  });
});
/** @internal */
export type GetEquipmentBulkEditViewRequest$Outbound = {
  device_kind: string;
  device_ids?: Array<string> | undefined;
  agent_id: string;
};

/** @internal */
export const GetEquipmentBulkEditViewRequest$outboundSchema: z.ZodType<
  GetEquipmentBulkEditViewRequest$Outbound,
  z.ZodTypeDef,
  GetEquipmentBulkEditViewRequest
> = z.object({
  deviceKind: z.string(),
  deviceIds: z.array(z.string()).optional(),
  agentId: z.string(),
}).transform((v) => {
  return remap$(v, {
    deviceKind: "device_kind",
    deviceIds: "device_ids",
    agentId: "agent_id",
  });
});

export function getEquipmentBulkEditViewRequestToJSON(
  getEquipmentBulkEditViewRequest: GetEquipmentBulkEditViewRequest,
): string {
  return JSON.stringify(
    GetEquipmentBulkEditViewRequest$outboundSchema.parse(
      getEquipmentBulkEditViewRequest,
    ),
  );
}
export function getEquipmentBulkEditViewRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetEquipmentBulkEditViewRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetEquipmentBulkEditViewRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetEquipmentBulkEditViewRequest' from JSON`,
  );
}
